import React, { Component } from "react";

import axios from "axios";

import schema from "./schema";
import { DOMAIN } from "config/config";

import Formizo from "Components/LabIZO/Formizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { Accessor, ErrorX, store } from "static";
import { DATA_LINK } from "connectors";

class SysEService extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      EServiceDoc: undefined,
    };
  }

  componentDidMount() {
    this._setAllStates(() => {
      this._getSetting();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(SysEService.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  Setting = {
    _onSubmit: async (data) => {
      let SettingLink = "/Config/EService/Edit";
      let SettingUrl = DOMAIN + SettingLink;

      let SettingPayloadOut = {
        EService: data.EServiceDoc,
        JWT: store.user.JWT,
      };

      try {
        store.isLoading(true);
        let res = await axios.post(SettingUrl, SettingPayloadOut);
        store.isLoading(false);

        if (res.data.Success) {
          this.Setting.onSuccess();
        } else {
          this.Setting.onFail("System message update fails.");
        }
      } catch (e) {
        this.Setting.onFail(ErrorX.Handle(e));
      }
    },

    onSuccess: () => {
      store.Alert("System message updated successfully", "success");
      this._getSetting();
    },

    onFail: (msg) => {
      store.isLoading(false);
      store.Alert(msg, "error");
    },
  };

  _getSetting = async () => {
    let link = "/Config/EService/Edit";
    let url = DOMAIN + link;

    let payloadOut = {
      JWT: store.user.JWT,
    };

    try {
      store.isLoading(true);
      let res = await axios.post(url, payloadOut);
      store.isLoading(false);

      let { Success, payload } = res.data;

      let EServiceDoc = {
        EServiceDoc: payload,
      };

      if (Success) {
        this.setState({
          EServiceDoc: EServiceDoc,
        });
      } else {
        store.Alert(payload, "error");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  renderForm() {
    let { EServiceDoc } = this.state;
    if (EServiceDoc === undefined) return;

    let defaultValue = {
      ...EServiceDoc,
    };
    return <Formizo height="100%" schema={schema.EServiceSetting} buttons={["Revert", "Submit"]} onSubmit={this.Setting._onSubmit} defaultValue={defaultValue} />;
  }

  render() {
    return <VStack height="100%">{this.renderForm()}</VStack>;
  }
}

export default SysEService;
